export const HOME_TABS: string[] = ["Home", "Pricing", "Profile"];
